module.exports = __webpack_public_path__ + "static/img/billingcard_bg.b6a7b77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/billingcard_bg.png
// module id = e2/d
// module chunks = 0